var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { PRICE_CHECKBOX_TITLE, PRICE_COLLAPSE, PRICE_EXPAND, TABLE, TABLE_BODY_ROW, TABLE_BODY_CELL, PRICE_TITLE, PRICE_QUANTITY, PRICE_AMOUNT, FLEX_NOWRAP } from "../../../classConstants";
import { getClassName } from "../../../helpers";
import { Flex } from "../../Flex";
import { ReactiveInput } from "../Input/Input";
import parse from "html-react-parser";
var priceSelectFactory = function () {
    var PriceSelect = function (props) {
        var positions = props.positions, type = props.type, className = props.className, label = props.label, fieldName = props.fieldName, otherProps = __rest(props, ["positions", "type", "className", "label", "fieldName"]);
        // const { t } = useTranslation();
        // const [showBillPositions, setShowBillPositions] = useState(false);
        // const handleMoreClick = (e) => {
        //     e.preventDefault();
        //     setShowBillPositions(!showBillPositions);
        // }
        var getTitle = function () {
            // const text = showBillPositions ? "pay.show_less_price_info" : "pay.show_more_price_info";
            return React.createElement(React.Fragment, null,
                React.createElement("span", { className: PRICE_CHECKBOX_TITLE }, parse(label || "")));
        };
        var getPositionRows = function () {
            var cellClass = function (prop) { return getClassName(TABLE_BODY_CELL, prop); };
            return positions.map(function (_a, i) {
                var title = _a.title, quantity = _a.quantity, price = _a.price;
                return (React.createElement("tr", { key: i, className: TABLE_BODY_ROW },
                    React.createElement("td", { className: cellClass(PRICE_TITLE) },
                        " ",
                        title,
                        " "),
                    React.createElement("td", { className: cellClass(PRICE_QUANTITY) },
                        " \u00D7 ",
                        quantity,
                        " "),
                    React.createElement("td", { className: cellClass(PRICE_AMOUNT) },
                        " ",
                        price,
                        " ")));
            });
        };
        var getDescription = function () {
            // if (!showBillPositions) return null;
            return React.createElement(React.Fragment, null,
                React.createElement(PriceTable, { className: TABLE },
                    React.createElement("tbody", null, getPositionRows())));
        };
        return (React.createElement(BillsWrap, { className: getClassName(className, "ws-bills") },
            React.createElement(ReactiveInput, __assign({ type: "checkbox", className: FLEX_NOWRAP }, otherProps, { name: fieldName || otherProps.name, label: getTitle() })),
            getDescription()));
    };
    var BillsWrap = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        --ws-input-margin: 0;\n    "], ["\n        --ws-input-margin: 0;\n    "])));
    var PriceTable = styled.table(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 100%;\n        border-collapse: collapse;\n        table-layout: auto !important;\n        &, th, td {\n            padding: 0;\n            border: 0 !important;\n        }\n\n        margin-top: .5em;\n        margin-bottom: 1em;\n    "], ["\n        width: 100%;\n        border-collapse: collapse;\n        table-layout: auto !important;\n        &, th, td {\n            padding: 0;\n            border: 0 !important;\n        }\n\n        margin-top: .5em;\n        margin-bottom: 1em;\n    "])));
    return styled(PriceSelect)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        &, & > * {\n            width: 100%;\n        }\n\n        .", " {\n            width: 100%;\n        }\n\n        .", ",\n        .", " {\n            text-align: right;\n            padding-left: 15px;\n            white-space: nowrap;\n            min-width: 10ch;\n        }\n\n        .", " {\n            text-decoration: none;\n            color: inherit;\n            cursor: pointer;\n            // display: flex;\n            // align-items: center;\n\n            .", ",\n            .", " {\n                display: inline-block;\n                margin-left: 5px;\n            }\n\n            * {\n                display: inline-block;\n                // margin: 0 1ch 0 0;\n                margin: 0;\n            }\n        }\n    "], ["\n        &, & > * {\n            width: 100%;\n        }\n\n        .", " {\n            width: 100%;\n        }\n\n        .", ",\n        .", " {\n            text-align: right;\n            padding-left: 15px;\n            white-space: nowrap;\n            min-width: 10ch;\n        }\n\n        .", " {\n            text-decoration: none;\n            color: inherit;\n            cursor: pointer;\n            // display: flex;\n            // align-items: center;\n\n            .", ",\n            .", " {\n                display: inline-block;\n                margin-left: 5px;\n            }\n\n            * {\n                display: inline-block;\n                // margin: 0 1ch 0 0;\n                margin: 0;\n            }\n        }\n    "])), PRICE_TITLE, PRICE_QUANTITY, PRICE_AMOUNT, PRICE_CHECKBOX_TITLE, PRICE_EXPAND, PRICE_COLLAPSE);
};
export var PriceSelect = priceSelectFactory();
var templateObject_1, templateObject_2, templateObject_3;
